module.exports = __webpack_public_path__ + "img/image61.0c72e726.png";